import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';

import './CustomDomainCompletionModal.less';

const CustomDomainCompletionModal = ({ hideModalFn, dnsProvider }) => {
  const urlZola =
    'https://help.zola.com/hc/en-us/articles/360001340151-How-do-I-connect-a-domain-name-I-bought-through-Zola-to-my-wedding-website-';
  const urlOther =
    'https://help.zola.com/hc/en-us/articles/115001755071-How-do-I-connect-a-domain-name-I-purchased-somewhere-else-to-my-wedding-website-';
  let url = urlZola;
  // const { dnsProvider } = this.props;
  if (dnsProvider === 'other') {
    url = urlOther;
  }

  return (
    <div id="custom-domain-completion-modal">
      <div className="modal-header">
        <h1 className="text-btn hidden-xs">Did you just buy a custom domain?</h1>
        <h1 className="text-btn hidden visible-xs">Connect Your Custom Domain To Your Website</h1>
      </div>
      <div className="modal-body">
        <p className="hidden-xs">
          Fun! We&apos;ll walk you through connecting it to your wedding website.
        </p>
        <p className="hidden visible-xs">
          Did you purchase a custom website address? We&apos;ll show you how to connect it to your
          Zola site.
        </p>
        <div className="modal-actions pull-right">
          <ButtonV2
            component="a"
            className="modal-actions__continue-button"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={hideModalFn}
          >
            Continue
          </ButtonV2>
          <ButtonV2
            variant="secondary"
            className="modal-actions__cancel-button"
            onClick={hideModalFn}
          >
            I Didn&apos;t Buy One
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

CustomDomainCompletionModal.propTypes = {
  hideModalFn: PropTypes.func,
  dnsProvider: PropTypes.string,
};

// export default CustomDomainCompletionModal;
export default connect(null, null)(CustomDomainCompletionModal);



// WEBPACK FOOTER //
// ./src/components/common/modals/CustomDomainModal/CustomDomainCompletionModal.jsx